<template>
    <div :class="classObj" class="app-wrapper">
        <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
        <sidebar class="sidebar-container" :theme-color="themeColor"/>
        <april-fools />
        <div :class="{hasTagsView:needTagsView}" class="main-container">
            <div :class="{'fixed-header':fixedHeader}">
                <navbar @set-color="setColor"/>
                <tags-view v-if="needTagsView"/>
            </div>
            <slot>
                <app-main/>
            </slot>
            <right-panel v-if="showSettings">
                <settings/>
            </right-panel>
        </div>
    </div>
</template>

<script>
    import RightPanel from '@/components/RightPanel'
    import AprilFools from '@/components/AprilFools'
    import {AppMain, Navbar, Settings, Sidebar, TagsView} from './components'
    import ResizeMixin from './mixin/ResizeHandler'
    import {mapState} from 'vuex'

    export default {
        name: 'Layout',
        components: {
            AppMain,
            AprilFools,
            Navbar,
            RightPanel,
            Settings,
            Sidebar,
            TagsView
        },
        mixins: [ResizeMixin],
        data(){
            return {
                themeColor:'',
            }
        },
        computed: {
            ...mapState({
                sidebar: state => state.app.sidebar,
                device: state => state.app.device,
                showSettings: state => state.settings.showSettings,
                needTagsView: state => state.settings.tagsView,
                fixedHeader: state => state.settings.fixedHeader,
                addRoutes: state => state.permission.addRoutes,
            }),
            classObj() {
                let obj = {
                    hideSidebar: !this.sidebar.opened,
                    openSidebar: this.sidebar.opened,
                    withoutAnimation: this.sidebar.withoutAnimation,
                    mobile: this.device === 'mobile'
                };
                if(this.themeColor){
                    obj[this.themeColor] = true;
                }

                return obj;
            }
        },
        mounted(){
            console.log('Layout index mounted',this.addRoutes,this.$route,document.querySelectorAll('.main-container'));
            if(this.$route.name == 'data_center'){
                let dataCenterRoute = this.addRoutes.find(item=>item.name=='data_center')||{};
                if(dataCenterRoute.children&&dataCenterRoute.children.length>0){
                    let childPageRoute = dataCenterRoute.children[0];
                    if(childPageRoute.children&&childPageRoute.children.length>0){
                        let grandsonRoute = childPageRoute.children;
                        let oppoTab = grandsonRoute.find(item=>item.name=='data_1');
                        if(oppoTab){
                            this.$router.replace(oppoTab.path);
                        }else{
                            this.$router.replace(childPageRoute.children[0].path);
                        }
                    }else{
                        this.$router.replace(childPageRoute.children[0].path);
                    }
                }
            }else if(this.$route.name == 'home'){
                console.log('this.$route.name home',this.$route);
                let homePageRoute = this.addRoutes.find(item=>item.name=='home')||{};
                if(homePageRoute.children&&homePageRoute.children.length>0){
                    let childPageRoute = homePageRoute.children[0];
                    if(childPageRoute){
                        this.$router.replace(childPageRoute.path);
                    }
                }
            }else{
                let curRoute = this._findItemByName(this.addRoutes,this.$route.name)||{};
                if(curRoute.children&&curRoute.children.length>0){
                    let childPageRoute = curRoute.children[0];
                    if(childPageRoute){
                        this.$router.replace(childPageRoute.path);
                    }
                }else{
                    if(this.$route.name!=curRoute.name){
                        this.$router.replace(curRoute.path);
                    }
                }
            }

            this.getThemeColor();
        },
        methods: {
            handleClickOutside() {
                this.$store.dispatch('app/closeSideBar', {withoutAnimation: false})
            },
            setColor(val){
                console.log(1,'setColor',val);
                this.themeColor = val;
                window.localStorage.setItem('themeColor',val);
            },
            getThemeColor(){
                let color = window.localStorage.getItem('themeColor');
                if(color){
                    this.themeColor = color;
                }
            },
            _findItemByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findItemByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/styles/mixin.scss";
    @import "~@/styles/variables.scss";

    .app-wrapper {
        @include clearfix;
        position: relative;
        height: 100%;
        width: 100%;

        &.mobile.openSidebar {
            position: fixed;
            top: 0;
        }
    }

    .drawer-bg {
        background: #000;
        opacity: 0.3;
        width: 100%;
        top: 0;
        height: 100%;
        position: absolute;
        z-index: 999;
    }

    .fixed-header {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 99;
        width: calc(100% - #{$sideBarWidth});
        transition: width 0.28s;
    }

    .hideSidebar .fixed-header {
        width: calc(100% - 54px)
    }

    .mobile .fixed-header {
        width: 100%;
    }
</style>
